export const NEW = 'new';

export const isNew = (value?: string | number) => value === NEW;
